export default "__VITE_ASSET__fdcc5938__"